<div class="d-flex flex-column note-container"
     #noteContainer
     (mouseenter) ="onMouseenter()"
     (mouseleave) ="onMouseleave()"
     (clickOutside)="onBlur($event)">
  <div *ngIf="!readonly" class="note-content">
    <textarea
      class="influencer-note"
      [ngStyle]="{'height': noteHeight + 'px'}"
      maxlength="1024"
      [(ngModel)]="note.content"
      (input)="onKeyUp($event)"
      (keydown)="onKeyDown($event)"
      (focus)="onKeyUp($event)"
      #contextBox
    ></textarea>
  </div>
  <div *ngIf="readonly" class="note-content">
    <div (click)="editNote()" class="content-inner">{{note.content}}</div>
  </div>
  <div *ngIf="!readonly && (!note.id || note.id === 0)" class="d-flex flex-row justify-content-end">
    <button class="button blue save-note-btn" [disabled]="!canSaveNote" (click)="createOrUpdateNote()">{{'common.btn.save' | translate}}</button>
  </div>
  <div *ngIf="note.id > 0 || isSampleNote" class="d-flex flex-row justify-content-start">
    <div class="d-flex flex-row note-info">
      <span *ngIf="!isSampleNote">{{lastModificationDate | date: 'd MMM yyyy'}}</span>
      <span *ngIf="!isSampleNote" class="space">-</span>
      <span>{{userName}}</span>
    </div>
    <div class="d-flex flex-row flex-auto justify-content-end" *ngIf="canEditNote">
      <a (click)="deleteNote(note.id)" class="d-flex button-icon">
        <img src="/assets/images/Trash_Icon.svg" class="icon-trash-delete-note">
      </a>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/inline-edit-note/inline-edit-note.component.html